var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"b-icon",class:[_vm.color, _vm.size, { shadow: _vm.boxShadow }],attrs:{"type":"button"}},[_c(require(("@/assets/icons/" + _vm.icon + ".svg")),{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }